/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Landing_Copy_To_ProjectInputs */



/**
* | output |
* | --- |
* | "Copy to another project" |
*
* @param {Artifact_Landing_Copy_To_ProjectInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_landing_copy_to_project = /** @type {((inputs?: Artifact_Landing_Copy_To_ProjectInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Landing_Copy_To_ProjectInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("In anderes Projekt kopieren")
	return /** @type {LocalizedString} */ ("Copy to another project")
});